/**
 * Adaptador para reusar las celdas de MUIDataTable (customBodyRender de
 * common/table/columns*.js y shared/table-columns/*) FUERA de la tabla, en las cards y el
 * panel de detalle del modo mobile. Las celdas cierran sobre el array `data` original por
 * closure y usan `tableMeta.rowIndex`, así que con un tableMeta mínimo bien formado
 * renderizan idéntico sin tocarlas.
 */

/** Columna visible en la card/panel (excluded = ids técnicos, no se pintan). */
export const isVisibleColumn = (column) =>
  column?.options?.display !== 'excluded' && column?.options?.display !== false;

/** Label plano de la columna (los multiline headers usan comas como salto). */
export const columnLabel = (column) => {
  const label = typeof column?.label === 'string' ? column.label : column?.name || '';
  return label.replace(/,/g, ' ');
};

/**
 * Renderiza el valor de una columna para una fila, replicando el contrato de MUIDataTable.
 *
 * @param {Object} column   definición de la columna ({ name, label, options })
 * @param {Object} row      fila ORIGINAL (objeto keyed por nombre de columna)
 * @param {number} rowIndex índice de la fila en los datos actuales
 * @param {number} columnIndex índice de la columna
 * @param {Array}  allRows  todas las filas actuales (para renderers que miran tableData)
 * @returns {React.ReactNode}
 */
export const renderCell = (column, row, rowIndex, columnIndex, allRows) => {
  const value = row?.[column.name];
  const render = column?.options?.customBodyRender;
  const renderLite = column?.options?.customBodyRenderLite;

  // La mayoría de las columnas ricas de OTRIX (foto + nombre, chip de estado, acciones) usan
  // `customBodyRenderLite`, que recibe el ÍNDICE de la fila y no el valor. Sin esta rama la
  // card y el panel de detalle salían con celdas vacías: sin foto, sin nombre y sin botones.
  if (renderLite) {
    try {
      return renderLite(rowIndex, columnIndex);
    } catch {
      return value ?? null;
    }
  }

  if (!render) return value ?? null;

  const tableMeta = {
    rowIndex,
    columnIndex,
    columnData: column,
    rowData: Object.values(row || {}),
    tableData: allRows,
    currentTableData: allRows.map((r, i) => ({ index: i, data: Object.values(r || {}) }))
  };

  try {
    return render(value, tableMeta, () => {});
  } catch {
    // Un renderer que dependa de internals reales de la tabla no debe tumbar la card.
    return value ?? null;
  }
};
